import React from 'react';
import { Modal, type UsdLedgerRowLike } from '@kioskgaming/ui';
import UsdWalletActivityView, { UsdWalletActivityHeader } from './UsdWalletActivityView';
import { mapUsdLedgerRowToActivity } from './usdWalletActivityRowMapper';

export type UsdWalletLedgerDetailModalProps = {
  row: UsdLedgerRowLike | null;
  onClose: () => void;
};

/**
 * Rich USD wallet transaction detail (Source & reason, flow, balance, financial breakdown).
 * Replaces the simplified shared {@link UsdWalletTransactionDetailModal} on admin USD pages.
 */
export const UsdWalletLedgerDetailModal: React.FC<UsdWalletLedgerDetailModalProps> = ({
  row,
  onClose,
}) => {
  if (!row) return null;

  const activity = mapUsdLedgerRowToActivity(row);

  return (
    <Modal
      isOpen
      onClose={onClose}
      size="lg"
      scrollable
      showCloseButton={false}
      customHeader={
        <UsdWalletActivityHeader
          onClose={onClose}
          type={activity.type}
          status={activity.status}
          createdAt={activity.createdAt}
          netDelta={activity.netDelta}
          referenceType={activity.referenceType}
          referencePrimaryLabel={activity.referencePrimaryLabel}
          counterpartDisplayName={activity.counterpartDisplayName}
          metadata={activity.metadata}
          ledgerRow={activity.ledgerRow}
          ownerPrimaryLabel={activity.ownerPrimaryLabel}
        />
      }
      containerClassName="max-w-[920px]"
      bodyClassName="px-4 pb-5 pt-2"
    >
      <UsdWalletActivityView {...activity} />
    </Modal>
  );
};

export default UsdWalletLedgerDetailModal;
